module.exports = {"title":"David Khourshid","talk":"Reactive Animations with CSS Variables","path":"/speakers/david-khourshid","type":"speaker","slug":"david-khourshid","twitter":"davidkpiano","github":"davidkpiano","website":"https://codepen.io/davidkpiano","companyWebsite":"https://www.counsyl.com/","company":"Counsyl","body":"<p>CSS variables are here, and they're much more powerful than you think. In this presentation, we will explore the many possibilities with mixing RxJS with CSS variables, including how they can be used to bring your web projects to life with dynamic animations that react to user input. And yes, there will be plenty of demos.</p>"}


/*****************
 ** WEBPACK FOOTER
 ** ./speakers/david-khourshid.md
 ** module id = 495
 ** module chunks = 0
 **/